export const SUPPORT_EMAIL = "hello@simbiosis.team";

/** The way out every error state ends with (project rule 6). */
export const SupportLink = ({ children = "contact us" }) => (
  <a
    href={`mailto:${SUPPORT_EMAIL}`}
    className="font-medium text-brand underline-offset-4 hover:underline"
  >
    {children}
  </a>
);

export const SupportLine = () => (
  <p className="text-sm text-muted-foreground">
    If you think this is a mistake on our side, please <SupportLink />.
  </p>
);
